import { CAT_ACTION_TYPE, CatActions } from './cat-type';
import { RootState } from '../../../../redux/root-reducer';

export enum CAT_STATE_KEY {
  LIST = 'list',
  ALERT_SUCCESS = 'alert_success',
  ALERT_FAILURE = 'alert_failure',
}

export type AlertData = {
  isVisible: boolean,
  translationValues: {
    categoryName: string,
  },
};

export type CatState = {
  [CAT_STATE_KEY.LIST]?: object,
  [CAT_STATE_KEY.ALERT_SUCCESS]?: AlertData,
  [CAT_STATE_KEY.ALERT_FAILURE]?: AlertData,
};

const initialState: CatState = {
  [CAT_STATE_KEY.LIST]: [],
  [CAT_STATE_KEY.ALERT_SUCCESS]: {
    isVisible: false,
    translationValues: {
      categoryName: '???',
    },
  },
  [CAT_STATE_KEY.ALERT_FAILURE]: {
    isVisible: false,
    translationValues: {
      categoryName: '???',
    },
  },
};

export const catReducers = (state = initialState, action: CatActions) => {
  switch (action.type) { // NOSONAR [typescript:S1301] followed usage pattern of reducer
    case CAT_ACTION_TYPE.SET_CAT_STATE:
      return {
        ...state,
        [action.payload.key]: action.payload.value
      };
    default:
      return state;
  }
};

export const catStateSelector = (key: CAT_STATE_KEY) => (state: RootState) => state.cat[key];
